import React, { Component } from 'react'
import { SelectMaterialModal, Flex } from 'hljd'
import { observer } from 'mobx-react'
import { addImageView } from '@core/utils'
import style from '../../style.module.less'
import {
  listApiMap,
  materialCount,
  pageSizeKey,
  materialName
} from '../../constant'

const cover = {
  1: item => {
    const { cover_path } = item
    return (
      <img
        className={style.mealCover}
        src={addImageView(cover_path, 160, 100)}
      />
    )
  },
  2: item => {
    const { cover_url } = item
    return (
      <img
        className={style.hallCover}
        src={addImageView(cover_url, 160, 100)}
      />
    )
  },
  3: item => {
    const {
      coverPhoto: { mediaPath }
    } = item
    return (
      <img
        className={style.styleCover}
        src={addImageView(mediaPath, 160, 213)}
      />
    )
  },
  4: item => {
    const origin_path = item?.cover?.video?.origin_path
    const image_path =
      origin_path &&
      `${origin_path}?vframe/jpg/offset/0|imageView2/1/w/160/h/100`
    return (
      <>
        <img className={style.videoCover} src={image_path} />
        <img
          className={style.videoIcon}
          src="https://qnm.hunliji.com/FuuJzhkq0sHy3R7AbVVSw4D1V3g9"
        />
      </>
    )
  },
  5: item => {
    const { cover_path } = item
    return (
      <>
        <img
          className={style.videoCover}
          src={addImageView(cover_path, 160, 100)}
        />
        <img
          className={style.videoIcon}
          src="https://qnm.hunliji.com/FuuJzhkq0sHy3R7AbVVSw4D1V3g9"
        />
      </>
    )
  }
}
@observer
export default class extends Component {
  renderCover = item => {
    const { materialType } = this.props.store
    if (!materialType) {
      return ''
    }
    return cover[materialType](item)
  }
  renderItem = ({ item, onSelect, selected }) => {
    const { id, title, name } = item
    return (
      <Flex key={id} hc vc d="v" onClick={onSelect} className={style.item}>
        {this.renderCover(item)}
        {(title || name) && <span className={style.name}>{title || name}</span>}
        <span className={style.selectIcon}>
          {selected ? (
            <img src="https://qnm.hunliji.com/FiTnAAkhVrSUgxU1FaZErxB3gs6t" />
          ) : (
            <img src="https://qnm.hunliji.com/FqylS4SVQT76zcNnvWjiMvhlXhol" />
          )}
        </span>
      </Flex>
    )
  }

  render() {
    const {
      isShowModal,
      materialType,
      selectedList,
      hideModal,
      submitMaterial,
      setSelectedList
    } = this.props.store
    const listApi = materialType && listApiMap[materialType]
    const okText =
      materialType && materialCount[materialType] > 1
        ? `确定(${selectedList.length}/${materialCount[materialType]})`
        : '确定'
    const disabled =
      materialType && selectedList.length === materialCount[materialType]
        ? false
        : true
    const maxCount = materialType && materialCount[materialType]
    const pSizeKey =
      materialType && pageSizeKey[materialType]
        ? pageSizeKey[materialType]
        : 'perPage'
    const title = materialType && (
      <h3>
        <span className={style.title}>{`选择${
          materialName[materialType]
        }`}</span>
        <span className={style.subTitle}>{`请选择${maxCount}个${
          materialName[materialType]
        }参与本次评选`}</span>
      </h3>
    )
    return (
      <SelectMaterialModal
        width={800}
        destroyOnClose
        title={title}
        visible={isShowModal}
        okButtonProps={{ disabled: disabled, className: style.okBtn }}
        cancelButtonProps={{ type: 'primary', ghost: true }}
        okText={okText}
        onCancel={hideModal}
        onOk={submitMaterial}
        api={listApi}
        renderItem={this.renderItem}
        onSelect={setSelectedList}
        selectedList={selectedList}
        className={style.selectModal}
        pageSizeKey={pSizeKey}
        maxCount={maxCount}
      />
    )
  }
}
